import AssignmentTable from "./AssignmentTable";
import AssignmentSubmissions from "./AssignmentSubmissions";
import { useState, useEffect } from "react";
import { useT } from "../../../stores/uiLang";
import { TD_T } from "../../../i18n/teacherDashboard";

export default function AssignmentsSection() {
  const t = useT(TD_T);
  const [activeFilter, setActiveFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const filterTypes = ["All", "Quizzes"];

  // Debounce search query
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  return (
    <section className="mb-10" id="assignments-section">
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-lg font-medium text-gray-900">
          {t.assignmentsTitle}
        </h2>
        <div className="flex items-center space-x-3">
          <div className="relative">
            <input
              type="text"
              placeholder={t.searchAssignments}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="rounded-md border border-gray-300 shadow-sm px-4 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 pr-8"
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <svg
                className="h-4 w-4 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-5 flex flex-wrap">
        {filterTypes.map((type) => (
          <button
            key={type}
            onClick={() => setActiveFilter(type)}
            className={`mt-2 px-3 py-1 text-sm border rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 mr-2 ${
              activeFilter === type
                ? "bg-indigo-600 text-white border-indigo-600"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
            }`}
          >
            {t.filterLabels[type] ?? type}
          </button>
        ))}
      </div>

      <AssignmentTable
        activeFilter={activeFilter}
        searchQuery={debouncedSearchQuery}
      />

      <div className="mt-10">
        <AssignmentSubmissions activeFilter={activeFilter} />
      </div>
    </section>
  );
}
